/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Role services
  Date: may 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';

export const getRoleList = (url) => {
  return API.get(`roles/roles`, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};
